import React from "react";
import Image from "components/image";
import Stars from "components/stars";
import Link from "helpers/link";
import { CURRENCY } from "utils/constants";
import Money from "components/money";

const ProductBlocks = ({ data }) => (
    <div className="container mx-auto">
        <div className="titleWrapper">
            <div><h1 className="text-3xl text-blue-700 mt-0 mb-4">{ data?.title }</h1></div>
            <div><h2 className="text-xl text-blue-700 font-medium mt-0 mb-8">{ data?.subtitle }</h2></div>
        </div>
        <div className={`grid grid-cols-1 sm:grid-cols-2 ${data?.productsPerRow === 4 ? "lg:grid-cols-4" : "lg:grid-cols-3"} gap-4`}>
            {data?.products?.map((product) => (
                <div className="col transition-shadow ease-in-out hover:shadow-[0_0_10px_rgba(0,0,0,0.3)] rounded-lg">
                    <Link
                        to={product?.link}
                        key={product?.title}
                    >
                        <div className="image-classes-here">
                            <Image image={product?.image.asset} alt={product.image?.alt} />
                        </div>
                        <div className="bg-gray-100 text-classes-here px-3 py-2 rounded-b-lg">
                            <div>
                                <p className="text-[13px] text-blue-700">{ product.title }</p>
                            </div>
                            <div>
                                <Stars rating={product.rating} className="!gap-0 my-1" />
                            </div>
                            <div className="text-sm font-medium text-blue-700">
                                <span>Starting From </span> 
                                <Money value={{ currencyCode: CURRENCY, amount: product.price }} /> 
                            </div>
                        </div>
                    </Link>
                </div>
            ))}
        </div>
    </div>
);

export default ProductBlocks;
